<template>
  <div class="media-container" v-viewer="{ movable: true, transition: false, toolbar: true, url: 'data-original' }">
    <a-row :gutter="[16, 16]">
      <a-col :span="6" :lg="8" :xl="6" v-for="(item, index) in files" :key="index">
        <div class="media-wrapper">
          <div class="media-block">
            <div class="ribbon" v-if="item.isChoice"><div class="ribbon-text">精选</div></div>
            <div class="media-file">
              <img class="img-fluid" :class="[`viewerImg-${index}`]" v-lazy="`${baseURL}/file/img?id=${item.fileId}&belongId=${projectId}&fileSign=P01&thumb=1`" :data-original="`${baseURL}/file/img?id=${item.fileId}&belongId=${projectId}&fileSign=P01`" v-if="item.classify == 'image'" />
              <!-- <player :url="`${baseURL}/file/view?id=${item.fileId}&belongId=${projectId}&fileSign=P01`" :config="{ videoInit: true }" v-else-if="item.classify == 'video'" /> -->
              <img class="img-doc" src="~@/assets/images/file_word.svg" v-else-if="item.classify == 'word'" />
              <img class="img-doc" src="~@/assets/images/file_excel.svg" v-else-if="item.classify == 'excel'" />
              <img class="img-doc" src="~@/assets/images/file_ppt.svg" v-else-if="item.classify == 'ppt'" />
              <img class="img-doc" src="~@/assets/images/file_compress.svg" v-else-if="item.classify == 'compress'" />
              <img class="img-doc" src="~@/assets/images/file_txt.svg" v-else-if="item.classify === 'txt'" />
              <img class="img-doc" src="~@/assets/images/file_pdf.svg" v-else-if="item.classify === 'pdf'" />
              <img class="img-doc" src="~@/assets/images/file_video.svg" v-else-if="item.classify === 'video'" />
              <img class="img-doc" src="~@/assets/images/file_default.svg" v-else />
            </div>
            <div class="media-title ellipsis-2-lines">{{ item.file.fileOriginName }}</div>
          </div>
          <div class="media-overlay">
            <div class="media-overlay-content">
              <a-button-group>
                <a-button class="v-px-sm" type="primary" title="查看大图" v-if="item.classify == 'image'" @click="previewFile(item, index)"><i class="fa fa-eye"></i></a-button>
                <a-button class="v-px-sm" type="primary" title="查看视频" v-else-if="item.classify == 'video'" @click="previewFile(item, index)"><i class="fa fa-eye"></i></a-button>
                <a-button class="v-px-sm" type="primary" title="查看文档" v-else-if="item.classify == 'pdf'" @click="previewFile(item, index)"><i class="fa fa-eye"></i></a-button>
                <a-button class="v-px-sm" type="primary" @click="downloadFile({ fileId: item.fileId, belongId: projectId, fileSign: 'P01', fileName: item.file.fileOriginName })"><i class="fa fa-download"></i></a-button>
                <a-button class="v-px-sm" type="primary" v-if="chosen" @click="item.isChoice = !item.isChoice">
                  <template v-if="item.isChoice">
                    <i class="fa fa-star-o v-mr-xs"></i>
                    取消精选
                  </template>
                  <template v-else>
                    <i class="fa fa-star v-mr-xs"></i>
                    设为精选
                  </template>
                </a-button>
                <a-button class="v-px-sm" type="primary" v-if="removable" @click="onRemove(item.fileId)"><i class="fa fa-trash-o"></i></a-button>
              </a-button-group>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>


<script>
import Player from '@/components/player'
export default {
  name: 'ReportMeidaContainer',
  components: {
    Player,
  },
  props: {
    medias: {
      type: Array,
      default: () => [],
    },
    projectId: {
      type: Number,
    },
    chosen: {
      type: Boolean,
      default: false,
    },
    removable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // imgFiles: [],
      // downloadFiles: [],
      files: [],
    }
  },
  watch: {
    medias() {
      this.splitFiles()
    },
  },
  methods: {
    splitFiles() {
      let imgFiles = []
      let downloadFiles = []
      let medias = this.medias
      medias.forEach(media => {
        let { file } = media
        let { fileFormat } = file
        let classify = 'default'
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(fileFormat)) {
          classify = 'image'
        } else if (['rar', 'zip', '7z'].includes(fileFormat)) {
          classify = 'compress'
        } else if (['xls', 'xlsx'].includes(fileFormat)) {
          classify = 'excel'
        } else if (['doc', 'docx', 'wps'].includes(fileFormat)) {
          classify = 'word'
        } else if (['mp4', 'wmv', 'rmvb', 'avi', 'mov', 'mkv', 'flv'].includes(fileFormat)) {
          classify = 'video'
        } else if (['ppt', 'pptx'].includes(fileFormat)) {
          classify = 'ppt'
        } else if (['pdf'].includes(fileFormat)) {
          classify = 'pdf'
        }
        media.classify = classify
        if (classify === 'image' || classify === 'video') {
          imgFiles.push(media)
        } else {
          downloadFiles.push(media)
        }
      })
      this.files = medias
      // this.files = imgFiles.concat(downloadFiles)
    },
    previewFile(file, index) {
      let { fileId, classify } = file
      if (classify == 'image') {
        this.$el.querySelector(`.viewerImg-${index}`).click()
      } else if (classify == 'video') {
        let { baseURL, projectId } = this
        let url = `${baseURL}/file/view?id=${fileId}&belongId=${projectId}&fileSign=P01`
        this.$root.$emit('previewVideo', url)
      } else if (classify == 'pdf') {
        let { baseURL, projectId } = this
        let url = `${baseURL}/file/view?id=${fileId}&belongId=${projectId}&fileSign=P01`
        this.$root.$emit('previewPdf', encodeURIComponent(url))
      }
    },
    onRemove(fileId) {
      let medias = this.medias.filter(d => d.fileId != fileId)
      this.$emit('update', medias)
    },
  },
  mounted() {
    this.splitFiles()
  },
}
</script>

